const IS_DEV = true;

if(IS_DEV){
    window.ym = function(counterId, type, goalName) {
        console.debug('[YM MOCK]', { counterId, type, goalName });
    };
}

document.addEventListener('click', function handleMetrikaClick(event) {
    const targetElement = event.target.closest('[data-metrika]');
    if (!targetElement) return;

    const metrikaGoalName = targetElement.dataset.metrika;
    if (!metrikaGoalName) return;

    sendMetrikaGoal(metrikaGoalName);
});

function sendMetrikaGoal(goalName) {
    if (IS_DEV) {
        console.debug('[YM DEV]', goalName);
        return;
    }

    if (typeof ym !== 'function') {
        console.debug('YM not ready');
        return;
    }

    const METRIKA_COUNTER_ID = 108218163;
    ym(METRIKA_COUNTER_ID, 'reachGoal', goalName);
}